module.exports = __webpack_public_path__ + "static/media/ca_2.d08d5d1e.png";